export const displayClosingTime = (
  openingTime: string,
  closingTime: string
): string => {
  const openingTimeNumber = parseInt(openingTime.replace(":", ""))
  const closingTimeNumber = parseInt(closingTime.replace(":", ""))
  const after24 = openingTimeNumber > closingTimeNumber
  if (!after24) return closingTime

  const [clHour, clMin] = closingTime.split(":").map((str) => parseInt(str))
  return `${clHour + 24}:${("00" + clMin).slice(-2)}`
}

export const openingTimeRangeFilter = (
  openingTimeNumber: number,
  closingTimeNumber: number
) => ({ label }): boolean => {
  const after24 = openingTimeNumber > closingTimeNumber
  const timeNumber = parseInt(label.replace(":", ""))
  if (after24) {
    return (
      closingTimeNumber < timeNumber && timeNumber < closingTimeNumber + 2400
    )
  } else {
    return timeNumber < closingTimeNumber
  }
}

export const closingTimeRangeFilter = (openingTimeNumber: number) => ({
  label,
}): boolean => {
  const timeNumber = parseInt(label.replace(":", ""))
  return openingTimeNumber < timeNumber && timeNumber < openingTimeNumber + 2400
}
